import React, { Component } from 'react'
import styles from './styles.module.scss'
import cx from 'classnames'
import _ from 'lodash';
import numeral from 'numeral';
import { localizedStrings } from 'src/localization/index.jsx';


export default class DealGraphView extends Component {

    constructor(props) {
        super(props);

        this.state = {
        }

        this.renderContentCards = this.renderContentCards.bind(this);

        this.localizedDealinsights = localizedStrings.pages.dealInsights;
    }

    componentDidMount() {
    }

    formatNumber(value) {

        if (_.isNull(value) || _.isUndefined(value)) {
            return 0;
        }

        if (value % 1 !== 0) {
            return value.toFixed(2);
        }

        return value;

    }

    renderContentCards() {

        const count = numeral(_.get(this.props.metrics, "count", 0)).format("(0)");
        const value = numeral(_.get(this.props.metrics, "value", 0)).format("(0.0a)");
        const confidence = numeral(_.get(this.props.metrics, "confidence", 0)).format("(0)");

        return (
            <div className={styles.contentContainer}>
                <div className={styles.contentBody}>
                    <div className={styles.totalDealsContainer}>
                        <div className={styles.countContainer}>
                            <p className={styles.count}>{count}</p>
                            <p className={styles.title}>{this.localizedDealinsights.cards.active_deals}</p>
                        </div>
                    </div>
                    <div className={styles.revenueContainer}>
                        <div className={styles.countContainer}>
                            <p className={styles.count}>${value}</p>
                            <p className={styles.title}>{this.localizedDealinsights.cards.revenue}</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className={styles.dealContainer}>
                <div className={styles.dealCards}>
                    {this.renderContentCards()}
                </div>
            </div>
        )
    }
}